import React, { Component } from "react";
import { CardImg } from "reactstrap";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

import "./style.css";

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <footer>
          <Container>
            <Row className="">
              <Col xs={{ size: 12 }} sm={{ size: 4, offset: 1 }}>
                <Row className="justify-content-center">
                  <Col xs={{ size: 12 }}>
                    <CardImg
                      className="footer-logo"
                      top
                      src="img/lighthouse-logo.png"
                      alt="Card image cap"
                    />
                  </Col>
                </Row>
                <Row className="pb-3">
                  <Col xs={{ size: "auto" }} sm={{ size: "auto" }}>
                    <p className="address my-0">
                      3550 Lenox Rd NE
                      <br /> Atlanta, GA 30326
                      <br />
                      United States
                    </p>
                  </Col>
                  <Col xs={{ size: "auto" }} className="pt-sm-2">
                    <a
                      href="https://www.facebook.com/itslighthouse"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>

                    <a
                      href="https://www.linkedin.com/company/itslighthouse/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardImg
                        className="footer-icons"
                        top
                        src="img/linkedin-icon.png"
                        alt="Card image cap"
                      />
                    </a>
                    <a
                      href="https://twitter.com/itsatlighthouse"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardImg
                        className="footer-icons"
                        top
                        src="img/twitter-icon.png"
                        alt="Card image cap"
                      />
                    </a>
                  </Col>
                </Row>
              </Col>

              <Col className="footer-content" xs={{ size: 6 }} sm={{ size: 2, offset: 1 }}>
                <h3 className="list-padding"> Services </h3>
                <ul className="list-unstyled">
                  <li>
                    <Link className="list-unstyled" to="/browse">
                      <p className="list-padding f-list"> Courses</p>
                    </Link>
                  </li>
                  <li>
                    <Link className="list-unstyled" to="/companies">
                      <p className="list-padding f-list">For Companies </p>
                    </Link>
                  </li>
                  <li>
                    <Link className="list-unstyled" to="/stay-relevant">
                      <p className="list-padding f-list"> Stay Relevant</p>
                    </Link>
                  </li>
                  <li>
                    <Link className="list-unstyled" to="/stay-relevant">
                      <p className="list-padding f-list"> Cloud Academy</p>
                    </Link>
                  </li>
                  <li>
                    <Link className="list-unstyled" to="/stay-relevant">
                      <p className="list-padding f-list"> Cyber Security</p>
                    </Link>
                  </li>
                </ul>
              </Col>
             
              <Col className="footer-content" xs={{ size: 6 }} sm={{ size: 2 }}>
                <h3 className="list-padding"> About </h3>
                <ul className="list-unstyled">
                  <li>
                    <Link className="list-unstyled" to="/about-us">
                      <p className="list-padding f-list"> About Us</p>
                    </Link>
                  </li>
                  <li>
                    <Link className="list-unstyled" to="/contact-us">
                      <p className="list-padding f-list">Contact Us </p>
                    </Link>
                  </li>
                  <li>
                    <Link className="list-unstyled" to="/FAQs">
                      <p className="list-padding f-list"> FAQs</p>
                    </Link>
                  </li>
                </ul>
              </Col>
            </Row>

            <Row>
              <Col sm={{ size: 10, offset: 1 }}>
                <hr style={{ backgroundColor: "white", marginTop: "3rem" }} />
              </Col>
            </Row>
            <Row className="pt-1 mt-1">
              <Col sm={{ size: 3, offset: 1 }}>
                <p
                  style={{ fontSize: ".75rem", color: "grey" }}
                  className="list-unstyled mb-0"
                >
                  2019 Copyright Reserved
                </p>
              </Col>
              <Col sm={{ size: 1 }}>
                <Link className="list-unstyled" to="/terms-of-service">
                  <p
                    className="mb-0"
                    style={{ fontSize: ".75rem", color: "grey" }}
                  >
                    {" "}
                    Legal
                  </p>
                </Link>
              </Col>
              <Col sm={{ size: 2, offset: 1 }}>
                <Link className="list-unstyled" to="/privacy-policy">
                  <p
                    className="mb-0"
                    style={{ fontSize: ".75rem", color: "grey" }}
                  >
                    {" "}
                    Privacy Policy
                  </p>
                </Link>
              </Col>
              <Col sm={{ size: 3 }} className="pb-2">
                <Link className="list-unstyled" to="/terms-of-service">
                  <p
                    className="mb-0"
                    style={{ fontSize: ".75rem", color: "grey" }}
                  >
                    {" "}
                    Terms and Conditions
                  </p>
                </Link>
              </Col>
            </Row>
          </Container>
        </footer>
      </div>
    );
  }
}

export default Footer;
